import styled from 'styled-components';
import { theme } from '../theme';

interface StyledRadioButtonProps {
  checked?: boolean;
  disabled?: boolean;
  error?: boolean;
}

// Browsers default radio button is hidden.
export const HiddenRadioButton = styled.input.attrs({ type: 'radio' })`
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;

// An outside circle containing a checkmark as a child.
export const StyledRadioButton = styled.span<StyledRadioButtonProps>`
  height: ${theme.fontSizes.body};
  width: ${theme.fontSizes.body};

  background-color: ${(props) =>
    props.disabled ? theme.colors.primaryK1 : theme.colors.primaryW};

  border-style: solid;
  border-width: ${(props) => (props.error ? '2px' : '1px')};

  border-color: ${(props) => {
    if (props.disabled) {
      return theme.colors.primaryK3;
    }
    if (props.error) {
      return theme.colors.primaryR5;
    }

    return theme.colors.primaryK10;
  }};

  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 7px;
`;

// Container is a label, so that clicking anywhere checks the radio button.
export const StyledRadioButtonContainer = styled.label<StyledRadioButtonProps>`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  font-size: ${theme.fontSizes.body};

  /* Radio button changes when anything in the container is hovered over. */
  &:hover ${StyledRadioButton} {
    ${(props) =>
      !props.disabled && `background-color: ${theme.colors.primaryK1};`};
    ${(props) =>
      !props.disabled &&
      !props.error &&
      `border-color: ${theme.colors.primaryK7};`}
  }
`;

// An inside circle that is displayed only when the radio is clicked.
export const StyledRadioButtonCheckmark = styled.span<StyledRadioButtonProps>`
  height: 50%;
  width: 50%;
  border-radius: 50%;
  background-color: ${theme.colors.primaryT2};

  display: ${(props) => (props.checked ? 'default' : 'none')};
`;
